import { render, staticRenderFns } from "./addPoster.vue?vue&type=template&id=0e850a7d&scoped=true&"
import script from "./addPoster.vue?vue&type=script&lang=js&"
export * from "./addPoster.vue?vue&type=script&lang=js&"
import style0 from "./addPoster.vue?vue&type=style&index=0&id=0e850a7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e850a7d",
  null
  
)

export default component.exports